export default __webpack_public_path__ + "static/media/newbrochureIconBranded.38af351b.svg";